if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => this.init());
    }

    disconnectedCallback() {
      if (this.tabs && this.onTabClick) {
        this.tabs.forEach((tab) => {
          tab.removeEventListener('click', this.onTabClick);
        });
      }
    }

    init() {
      this.target = this.dataset.target;
      if (!this.target) return;

      this.slider = document.getElementById(this.target);
      if (!this.slider) return;

      this.productLimit = parseInt(this.slider.dataset.productLimit || '6', 10);
      this.tabs = Array.from(
        this.querySelectorAll('a[data-collection], button[data-collection]')
      );

      if (!this.tabs.length) return;

      this.randomizedCollections = new Set();
      this.onTabClick = this.handleTabClick.bind(this);

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.onTabClick);
      });

      const activeTab =
        this.tabs.find((tab) => tab.classList.contains('active')) || this.tabs[0];

      if (activeTab && activeTab.dataset.collection) {
        this.setActiveTab(activeTab);
        this.toggleCollection(activeTab.dataset.collection);
      }

      if (window.Shopify && Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const selectedTab = event.target.closest('[data-collection]');
          if (!selectedTab) return;

          selectedTab.dispatchEvent(
            new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
            })
          );
        });
      }
    }

    handleTabClick(event) {
      event.preventDefault();

      const tab = event.currentTarget;
      const handle = tab.dataset.collection;

      if (!handle) return;

      this.setActiveTab(tab);
      this.toggleCollection(handle);
    }

    setActiveTab(activeTab) {
      this.tabs.forEach((tab) => {
        const isActive = tab === activeTab;
        tab.classList.toggle('active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    shuffle(array) {
      const arr = [...array];
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }
      return arr;
    }

    getCollectionItems(handle) {
      const slider = document.getElementById(this.target);
      if (!slider) return { promotions: [], products: [] };

      const items = Array.from(
        slider.querySelectorAll(`.columns[data-collection="${handle}"]`)
      );

      return {
        promotions: items.filter((item) => item.dataset.itemType === 'promotion'),
        products: items.filter((item) => item.dataset.itemType !== 'promotion'),
      };
    }

    randomizeCollection(handle) {
      if (this.randomizedCollections.has(handle)) return;

      const slider = document.getElementById(this.target);
      if (!slider) return;

      const flkty = window.Flickity ? Flickity.data(slider) : null;
      const flickitySlider = slider.querySelector('.flickity-slider');
      const container = flickitySlider || slider;

      const { promotions, products } = this.getCollectionItems(handle);
      if (!products.length && !promotions.length) return;

      const shuffledProducts = this.shuffle(products);
      const selectedProducts = shuffledProducts.slice(0, this.productLimit);
      const remainingProducts = shuffledProducts.slice(this.productLimit);

      [...promotions, ...selectedProducts, ...remainingProducts].forEach((item) => {
        container.appendChild(item);
      });

      this.randomizedCollections.add(handle);

      if (flkty) {
        flkty.reloadCells();
        flkty.resize();

        if (typeof flkty.reposition === 'function') {
          flkty.reposition();
        }

        if (typeof flkty.updateDraggable === 'function') {
          flkty.updateDraggable();
        }
      }
    }

    toggleCollection(handle) {
      const slider = document.getElementById(this.target);
      if (!slider) return;

      this.randomizeCollection(handle);

      const flkty = window.Flickity ? Flickity.data(slider) : null;
      const flickitySlider = slider.querySelector('.flickity-slider');
      const container = flickitySlider || slider;

      const allItems = Array.from(
        slider.querySelectorAll('.columns[data-collection]')
      );

      const activeItems = allItems.filter(
        (el) => el.dataset.collection === handle
      );

      const activePromotions = activeItems.filter(
        (el) => el.dataset.itemType === 'promotion'
      );

      const activeProducts = activeItems
        .filter((el) => el.dataset.itemType !== 'promotion')
        .slice(0, this.productLimit);

      const visibleItems = [...activePromotions, ...activeProducts];
      const inactiveItems = allItems.filter(
        (el) => el.dataset.collection !== handle || !visibleItems.includes(el)
      );

      allItems.forEach((el) => {
        el.classList.remove('carousel__slide');
        el.style.display = 'none';
        el.hidden = true;
      });

      [...visibleItems, ...inactiveItems].forEach((el) => {
        container.appendChild(el);
      });

      visibleItems.forEach((el) => {
        el.classList.add('carousel__slide');
        el.style.display = '';
        el.hidden = false;
      });

      if (flkty) {
        flkty.reloadCells();
        flkty.resize();

        if (typeof flkty.reposition === 'function') {
          flkty.reposition();
        }

        if (typeof flkty.updateDraggable === 'function') {
          flkty.updateDraggable();
        }

        flkty.select(0, false, true);
      }
    }
  }

  customElements.define('collection-tabs', CollectionTabs);
}
